import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Reveal } from "@/lib/motion";
import { SERVICES } from "@/data/content";
import { useConsult } from "@/context/ConsultContext";

function ServiceCard({ s, i }) {
  const Icon = Icons[s.icon] || Icons.Sparkles;
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
      className={`group relative rounded-2xl border border-slate-200 bg-white p-7 hover:-translate-y-1.5 hover:shadow-2xl hover:shadow-purple-100 hover:border-[var(--dm-purple)]/40 transition-[transform,box-shadow,border-color] duration-300 ${s.span || ""}`}
      data-testid={`service-card-${s.key}`}
    >
      <div className="w-12 h-12 rounded-xl grid place-items-center mb-5 text-white transition-transform duration-300 group-hover:scale-110" style={{ background: "linear-gradient(135deg,#6C2BD9,#2563EB)" }}>
        <Icon size={22} />
      </div>
      <h3 className="font-head font-bold text-xl text-slate-900 mb-2">{s.title}</h3>
      <p className="text-slate-600 leading-relaxed">{s.desc}</p>
      <div className="mt-5 flex items-center gap-1.5 text-sm font-head font-bold text-[var(--dm-purple)] opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-300">
        Learn more <Icons.ArrowRight size={15} />
      </div>
    </motion.div>
  );
}

export default function Services() {
  const { openConsult } = useConsult();
  return (
    <section id="services" className="py-24 lg:py-32 bg-[var(--dm-alt)] scroll-mt-20" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <span className="overline text-[var(--dm-purple)]">What We Do</span>
          <h2 className="font-head font-extrabold tracking-tighter text-4xl sm:text-5xl text-slate-900 mt-4 leading-[1.05]">
            Full-service marketing, <span className="text-gradient">engineered for growth</span>
          </h2>
          <p className="mt-5 text-lg text-slate-600">
            Every service is built around one goal — measurable business results. Pick a channel or let us orchestrate the whole funnel.
          </p>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => <ServiceCard key={s.key} s={s} i={i} />)}
        </div>

        <Reveal delay={0.1} className="mt-12 text-center">
          <button onClick={openConsult} data-testid="services-cta" className="inline-flex items-center gap-2 rounded-full px-8 py-4 font-head font-bold text-white transition-transform hover:-translate-y-1 hover:shadow-xl hover:shadow-purple-300" style={{ background: "linear-gradient(135deg,#6C2BD9,#2563EB)" }}>
            Get a Custom Strategy <Icons.ArrowRight size={18} />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
